import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSeguroID
    tipoSeguimientoID
    tipoSeguimiento
    empresaID
    empresa
    usuarioID
    usuario
    ramoSeguimiento
    ejercicioID
    ejercicio
    semanaAltaID
    numSemanaAlta
    estadoID
    estado
    estadoColor
    estadoEsFinal
    descripcion
    numpolEndoso
    inciso
    folio
    fechaAlta
    fechaSolicitud
    fechaIngreso
    fechaSeguimiento
    diasSeguimiento
    personalSeguimiento
    responsableID
    origenID
    origenTipo
    inicioVigencia
    finVigencia
    diasVigencia
    sumaAseg
    primaNeta
    primaTotal
    divisaID
    divisa
    responsable
    avance
`;

//PARA EL GET:

export const GET_SEGUIMIENTOSEGUROS = `
query get($filtro: InputGetSeguimientoSeguros){
    getSeguimientoSeguros(filtro:$filtro){
        ${CAMPOS}
    }
}
`;

//PARA EL GET ALL:

export const GET_ALL_SEGUIMIENTOSEGUROS = `
query filtroGetAll($filtro: InputGetSeguimientoSeguros){
    getAllSeguimientoSeguros(filtro: $filtro){
        ${CAMPOS}
    }
}
`;

//PARA LA TABLA:

export const TABLA_SEGUIMIENTOSEGUROS = `
query filtro($filtro: InputFilterSeguimientoSeguros){
    filterSeguimientoSeguros(filtro: $filtro){
        listado{
            ${CAMPOS}
        }
        registros
        paginas
    }
}
`;

export const getSeguimientoSeguros = async (filtro, token) => {
    try {
        let { getSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GET_SEGUIMIENTOSEGUROS
        });
        return getSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSeguimientoSeguros = async (variables, token) => {
    try {
        let { getAllSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEGUIMIENTOSEGUROS
        });
        return getAllSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
}

export const tablaSeguimientoSeguros = async (variables, token) => {
    try {
        let { filterSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_SEGUIMIENTOSEGUROS
        });
        return filterSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
}
